document.addEventListener('DOMContentLoaded', () => {
  // Reviews Swiper
  const reviewsSwiper = new Swiper('.reviews-swiper', {
    slidesPerView: 1.1,
    spaceBetween: 16,
    centeredSlides: false,
    grabCursor: true,
  });

  // Progress Swiper
  const progressSwiper = new Swiper('.progress-swiper', {
    slidesPerView: 1,
    spaceBetween: 24,
    allowTouchMove: true,
    navigation: {
      nextEl: '.progress-next',
      prevEl: '.progress-prev',
    },
    on: {
      slideChange: function () {
        updateProgressBar(this.activeIndex);
      }
    }
  });

  // Update progress bar
  function updateProgressBar(index) {
    const labels = document.querySelectorAll('.progress-label');
    const dots = document.querySelectorAll('.progress-dot');
    const fill = document.querySelector('.progress-bar-fill');

    // Update labels
    labels.forEach((label, i) => {
      label.classList.toggle('active', i === index);
    });

    // Update dots
    dots.forEach((dot, i) => {
      dot.classList.remove('active', 'passed');
      if (i === index) {
        dot.classList.add('active');
      } else if (i < index) {
        dot.classList.add('passed');
      }
    });

    // Update fill
    const fillPercent = (index / (dots.length - 1)) * 100;
    fill.style.width = fillPercent + '%';
  }

  // Click on progress labels/dots to navigate
  document.querySelectorAll('.progress-label, .progress-dot').forEach(el => {
    el.addEventListener('click', () => {
      const index = parseInt(el.dataset.index);
      progressSwiper.slideTo(index);
    });
  });

  // Experts Tabs & Cards
  const expertTabs = document.querySelectorAll('.expert-tab');
  const expertCards = document.querySelectorAll('.expert-card');
  const tabsContainer = document.querySelector('.experts-tabs');

  expertTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const index = tab.dataset.index;

      // Update tabs
      expertTabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      // Update cards
      expertCards.forEach(card => card.classList.remove('active'));
      document.querySelector(`.expert-card[data-index="${index}"]`).classList.add('active');

      // Scroll tab into view
      tab.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    });
  });

  // Accordion
  document.querySelectorAll('.accordion-header').forEach(button => {
    button.addEventListener('click', () => {
      const item = button.parentElement;
      const content = button.nextElementSibling;
      const isActive = item.classList.contains('active');

      // Close all items
      document.querySelectorAll('.accordion-item').forEach(i => {
        i.classList.remove('active');
        i.querySelector('.accordion-content').style.maxHeight = '0';
      });

      // Open clicked item if it wasn't active
      if (!isActive) {
        item.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
});